module.exports = __webpack_public_path__ + "img/P150T_weapon_81.cb16ee03.png";